import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {

  constructor() { }

  @Input() breadcrumb: object;

  ngOnInit() {
    this.processBreadCrumbLinks();
  }
  private processBreadCrumbLinks() {
  }
}
